export default function ServerController(
  $q,
  $rootScope,
  alerts,
  userService,
  bcpDataService,
  confirmDialog,
  editServerDialog,
  ssDialogService
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;

  vm.handleEdit = _handleEdit;
  vm.handleDelete = _handleDelete;

  _activate()

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initEventListeners() {
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _handleEdit($event) {
    ssDialogService.dialogs.bcp.editServerDialog = ssDialogService.alert(
      editServerDialog.getOptions($event, {
        assessmentId: vm.assessmentId,
        server: vm.server,
        addCallback: null,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editServerDialog);
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.confirmDeleteServerDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Server?',
        message: `Are you sure you want to delete the Server "${vm.server.name}"?`,
        handleYesClick() {
          _handleConfirmDelete(vm.server);
        },
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteServerDialog);
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteServerDialog);
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _handleConfirmDelete(server) {
    return bcpDataService.deleteServer(server.assessmentServerId).then(() => {
      alerts.success('The Server has been deleted successfully.');
      $rootScope.$broadcast('setDocumentRegenerateFlag');
      $rootScope.$broadcast('refreshBCPServers');
      _closeDeleteDialog();
    })
    .catch(() => {
      alerts.error('An error occurred deleting the Server.');
    });
  }
}

ServerController.$inject = [
  '$q',
  '$rootScope',
  'alerts',
  'userService',
  'bcpDataService',
  'confirmDialog',
  'editServerDialog',
  'ssDialogService'
];
